<template>
  <div>
    <SecondaryMenu
      :items="items"
      :gameName="gameName"
      @changeGames="changeGames"
      v-if="items.includes(gameName)"
    />
    <h1 v-if="title">{{ title }}</h1>
    <div v-if="content" v-html="content"></div>

    <Sigle v-if="gameName == 'tweet'" />

    <Modal :gameName="gameName" v-if="items.includes(gameName)" :modal="modal" />
  </div>
</template>

<script>
import Sigle from "../tweet/Sigle";
import Modal from "./Modal";
import SecondaryMenu from "./SecondaryMenu.vue";
export default {
  name: "Aside",
  components: {
    Sigle,
    Modal,
    SecondaryMenu,
  },
  props: {
    gameName: String,
    title: String,
    content: String,
    modal: Object
  },
  data: () => ({
    items: ["chappe", "morse", "baudot"],
  }),
  methods: {
    changeGames(event) {
      this.$emit("changeGames", { param: event.param });
    },
  },
};
</script>


